import moment from "moment-timezone";

export function closureRetreatTitle(row: {
  parishName?: string;
  language?: string;
  location?: string;
}) {
  return [
    row.parishName,
    row.language
      ? `(${row.language[0].toUpperCase()}${row.language.slice(1)})`
      : null,
    row.location
      ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
      : "",
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
}

export function formatClosureDateRange(from?: string, to?: string) {
  if (!from || !to) return "";
  if (moment(from).isSame(to, "day")) {
    return moment(from).tz("America/New_York").format("MMM D, YYYY");
  }
  if (moment(from).isSame(to, "month")) {
    return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to)
      .tz("America/New_York")
      .format("D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
  }
  return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to)
    .tz("America/New_York")
    .format("MMM D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
}

export function isUpcomingClosure(row: { dateFrom?: string; dateTo?: string }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dateFrom = row.dateFrom ? new Date(row.dateFrom) : null;
  const dateTo = row.dateTo ? new Date(row.dateTo) : null;
  if (dateFrom) dateFrom.setHours(0, 0, 0, 0);
  if (dateTo) dateTo.setHours(0, 0, 0, 0);
  return Boolean(
    (dateFrom && dateFrom >= today) || (dateTo && dateTo >= today),
  );
}

export function isClosedValid(row: { retreatCloseStatus?: boolean | number }) {
  return row.retreatCloseStatus === false || row.retreatCloseStatus === 1;
}
